import React from 'react';
import * as S from './styles';

import locationIcon from "../../../assets/icons/icon-location.svg";
import agronomoIcon from "../../../assets/icons/icon-user-com-chapeu.svg";
import IconAtencao from "../../../assets/icons/icon-status-nao-enviado.png";
import { isOmie } from '../../../services/globalFunctions';

import {
  truncateText,
  getStatusMeta,
  formatQuantidade,
  formatarData,
  formatLocal,
  getProducts,
  isCadastroIncompleto,
  isProdutoIncompativelComEstado,
  isFazendaAusente,
  getMotivoAtencao,
} from './helpers';

const CardSolicitacaoMobile = ({ item, disabled, itemKey }) => {
  const products = getProducts(item);
  const statusMeta = getStatusMeta(item?.status);
  const incompleto = isCadastroIncompleto(item) || isProdutoIncompativelComEstado(item) || isFazendaAusente(item);

  return (
    <>
      {incompleto && 
      (<S.HeaderRow>
        <S.AttentionIconWrapper>
          <img
            src={IconAtencao}
            alt="Ícone de atenção"
            title={getMotivoAtencao(item)}
            width="18"
            height="18"
          />
        </S.AttentionIconWrapper>
      </S.HeaderRow>)}

      <S.HeaderRow>
        <S.DateText $disabled={disabled}>
          {String(formatarData(item?.data_emissao || '')).toUpperCase()}
        </S.DateText>


        <S.StatusBadge $variant={statusMeta.variant}>
          {statusMeta.text}
        </S.StatusBadge>
      </S.HeaderRow>

      <S.TopRow>
        <S.ProductColumn>
          {products.map((product, pIdx) => (
            <S.ProductText key={`${itemKey}_product_${pIdx}`} $disabled={disabled}>
              {product?.nome_comercial || item?.nome_comercial || '-'}
            </S.ProductText>
          ))}
        </S.ProductColumn>

        <S.QtyColumn>
          {products.map((product, pIdx) => (
            <S.QtyBadge key={`${itemKey}_q_${pIdx}`}>
              <S.QtyText>{String(formatQuantidade(product) || '').toUpperCase()}</S.QtyText>
            </S.QtyBadge>
          ))}
        </S.QtyColumn>
      </S.TopRow>

      <S.MetaSection>
        <S.MetaRow>
          <S.BlueBadge>
            <S.BlueBadgeText>
              {String(item?.produtor_nome || '-').toUpperCase()}
            </S.BlueBadgeText>
          </S.BlueBadge>
        </S.MetaRow>

        <S.MetaRowSplit>
          <S.LocalBadge>
            <img src={locationIcon} alt="Ícone de localização" width="14" height="14" />
            <S.LocalBadgeText>
              {String(formatLocal(item) || '-').toUpperCase()}
            </S.LocalBadgeText>
          </S.LocalBadge>

          {!isOmie() && (
            <S.DarkBadge>
              <S.DarkBadgeText>
                {String(item?.cultura_nome_comum || '-').toUpperCase()}
              </S.DarkBadgeText>
            </S.DarkBadge>
          )}
        </S.MetaRowSplit>
      </S.MetaSection>

      <S.ExtraMetaRow>
        {!isOmie() && (
          <S.ExtraMetaLeft>
            <S.TechBadge>
              <img src={agronomoIcon} alt="Ícone do responsável técnico" width="14" height="14" />
              <S.TechBadgeText $disabled={disabled}>
                {truncateText(item?.agronomo_nome, 14)}
              </S.TechBadgeText>
            </S.TechBadge>
          </S.ExtraMetaLeft>
        )}

        {!isOmie() && (
          <S.ExtraMetaCenter>
            <S.InlineMetaText $disabled={disabled}>
              {truncateText(item?.agro_subsidiaries?.nome_fantasia || item?.filial_nome, 14)}
            </S.InlineMetaText>
          </S.ExtraMetaCenter>
        )}

        <S.ExtraMetaRight $solo={isOmie()}>
          <S.OrderInlineText $disabled={disabled}>
            {`PEDIDO: ${String(item?.id_pedido || '-').toUpperCase()}`}
          </S.OrderInlineText>
        </S.ExtraMetaRight>
      </S.ExtraMetaRow>
    </>
  );
};

export default CardSolicitacaoMobile;
